module.exports = __webpack_public_path__ + "media/images/pc/items/gift/kiribako_03-6e3f43f7ac2655242fdb0b9f84b1f1ac.jpg";